// menuData reference — maps every page in the design menu: page id <-> slug <-> page name.
// Navigation routes by SLUG (never by page id). Source of truth for the layout menus.
export const MENU_PAGES = [
  {
    "pageId": 73907,
    "pageGuid": "70e19bc9-32b7-412f-97c5-a8b91329e559",
    "slug": "self-registration",
    "name": "Self Registration"
  },
  {
    "pageId": 73908,
    "pageGuid": "9eff4202-0777-48a4-b747-ac6a3192ea1a",
    "slug": "forgot-password",
    "name": "Forgot Password"
  },
  {
    "pageId": 73909,
    "pageGuid": "3f378577-d663-44dd-beef-dca45aaff51f",
    "slug": "tenant-users-access-management",
    "name": "Users & Access Control"
  },
  {
    "pageId": 73910,
    "pageGuid": "f2e8c0b6-06bf-4b43-be36-df18bafcb9bf",
    "slug": "sign-in",
    "name": "Sign In"
  },
  {
    "pageId": 73911,
    "pageGuid": "f91519d5-4158-4513-95d3-15089f521bcd",
    "slug": "role-permissions-security-policies",
    "name": "Security & Permissions"
  },
  {
    "pageId": 73912,
    "pageGuid": "ff342a17-6648-4993-8971-bf3e1c12fa6a",
    "slug": "resident-portal-defect-submission",
    "name": "Resident Portal"
  },
  {
    "pageId": 73913,
    "pageGuid": "ba82026c-2df5-4e57-b1dd-25a7d5dd9781",
    "slug": "service-desk-call-email-intake",
    "name": "Service Desk Console"
  },
  {
    "pageId": 73914,
    "pageGuid": "805ef5ba-c028-45d6-abea-1b52ea93694d",
    "slug": "qr-defect-intake-pwa",
    "name": "QR Defect Intake PWA"
  },
  {
    "pageId": 73915,
    "pageGuid": "b64044d2-6198-4fdf-8da0-efe6e80ea360",
    "slug": "kanban-triage-sla-board",
    "name": "Kanban Triage Board"
  },
  {
    "pageId": 73916,
    "pageGuid": "678c1051-9372-4aad-84c9-8f9d05950a2b",
    "slug": "work-order-packaging-dispatch-board",
    "name": "Work Order Dispatch"
  },
  {
    "pageId": 73917,
    "pageGuid": "ccbc7461-93f1-45e6-b6a5-8028363fcf7d",
    "slug": "trade-categories-rate-cards",
    "name": "Trade Rate Cards"
  },
  {
    "pageId": 73918,
    "pageGuid": "c950e686-794b-4c24-8fce-6d081c37066a",
    "slug": "provider-profile-accreditation-management",
    "name": "Provider Compliance"
  },
  {
    "pageId": 73919,
    "pageGuid": "5ea8ab0a-4542-453e-9745-83d588f7da57",
    "slug": "contractor-quotation-builder",
    "name": "Quotation Builder"
  },
  {
    "pageId": 73920,
    "pageGuid": "2107285d-5995-4633-9afe-216cbe7395cf",
    "slug": "technician-mobile-execution-pwa",
    "name": "Technician Mobile PWA"
  },
  {
    "pageId": 73921,
    "pageGuid": "bf7e5cb8-877f-4bc0-8fe2-c7d5992d5535",
    "slug": "dual-sign-off-resident-verification",
    "name": "Dual Sign-Off & Review"
  },
  {
    "pageId": 73922,
    "pageGuid": "131c8c20-e27f-4210-afc6-03c8e49a10bf",
    "slug": "multi-tier-quotation-approvals-queue",
    "name": "Approvals Queue & AP"
  },
  {
    "pageId": 73923,
    "pageGuid": "0f902923-62fd-497b-a015-84b8e3349219",
    "slug": "operational-sla-maintenance-dashboard",
    "name": "Executive SLA Dashboard"
  },
  {
    "pageId": 73924,
    "pageGuid": "31f5b87b-752b-4855-947b-cdfd6d7ec260",
    "slug": "compliance-audit-trail-explorer",
    "name": "Audit Trail Explorer"
  },
  {
    "pageId": 73925,
    "pageGuid": "2c1dc52a-b4e5-47ad-9075-111fe9219019",
    "slug": "spatial-hierarchy-property-tree",
    "name": "Spatial Property Tree"
  },
  {
    "pageId": 73926,
    "pageGuid": "76509753-9b78-42ff-978c-0e05e179a289",
    "slug": "provider-benchmark-scorecard",
    "name": "Performance Scorecards"
  },
  {
    "pageId": 73927,
    "pageGuid": "fd7cb609-b976-4c67-a3d8-f347bcf40a85",
    "slug": "tenant-configuration-custom-branding",
    "name": "Tenant Branding"
  },
  {
    "pageId": 73928,
    "pageGuid": "ab585636-0b47-4781-a7a9-23b99180092f",
    "slug": "batch-qr-code-generator-asset-placards",
    "name": "Batch QR Placards"
  },
  {
    "pageId": 73929,
    "pageGuid": "2e221443-7276-4d7f-a681-e5e15fad5ceb",
    "slug": "subscription-tier-seat-licensing",
    "name": "Properties & plans"
  },
  {
    "pageId": 73930,
    "pageGuid": "dec5b94d-2c0f-4183-bbdf-60166c589554",
    "slug": "invoicing-stripe-billing-portal",
    "name": "Invoicing & Payments"
  },
  {
    "pageId": 73931,
    "pageGuid": "31a34b85-5298-4411-9bb7-1fc677276487",
    "slug": "system-integrations-webhooks-monitor",
    "name": "Webhooks & Integrations"
  },
  {
    "pageId": 73932,
    "pageGuid": "838881ff-047e-453a-847a-4661cb05bbcf",
    "slug": "inspection-checklists-task-template-builder",
    "name": "Inspection Templates"
  },
  // Not part of the generated design menu: pageId is outside the generated range so it can never collide.
  {
    "pageId": 90001,
    "pageGuid": null,
    "slug": "resident-directory",
    "name": "Residents"
  },
  {
    "pageId": 90002,
    "pageGuid": null,
    "slug": "resident-charges",
    "name": "Resident charges"
  },
  {
    "pageId": 90003,
    "pageGuid": null,
    "slug": "inspections",
    "name": "Inspections"
  },
  {
    "pageId": 90004,
    "pageGuid": null,
    "slug": "assetos-integration",
    "name": "AssetOS Integration"
  }
];

// Slugs whose real page component exists. Menu links to any other slug fall back
// to the generic /404 page until ui-components-from-reference builds the page and
// adds its slug here.
export const BUILT_SLUGS = ['sign-in', 'self-registration', 'forgot-password', 'role-permissions-security-policies', 'tenant-users-access-management', 'spatial-hierarchy-property-tree', 'batch-qr-code-generator-asset-placards', 'qr-defect-intake-pwa', 'resident-portal-defect-submission', 'service-desk-call-email-intake', 'kanban-triage-sla-board', 'work-order-packaging-dispatch-board', 'provider-profile-accreditation-management', 'trade-categories-rate-cards', 'contractor-quotation-builder', 'multi-tier-quotation-approvals-queue', 'technician-mobile-execution-pwa', 'dual-sign-off-resident-verification', 'tenant-configuration-custom-branding', 'operational-sla-maintenance-dashboard', 'provider-benchmark-scorecard', 'compliance-audit-trail-explorer', 'system-integrations-webhooks-monitor', 'subscription-tier-seat-licensing', 'invoicing-stripe-billing-portal', 'inspection-checklists-task-template-builder', 'resident-directory', 'resident-charges', 'inspections', 'assetos-integration'];

const BY_ID = Object.fromEntries(MENU_PAGES.map((p) => [p.pageId, p]));
const BY_SLUG = Object.fromEntries(MENU_PAGES.map((p) => [p.slug, p]));

export const getPageById = (pageId) => BY_ID[pageId];
export const getPageBySlug = (slug) => BY_SLUG[slug];

/** Slug-based route for a page id; falls back to /404 when the page is not built yet. */
export function routeForPageId(pageId) {
  const page = BY_ID[pageId];
  if (!page) return '/404';
  return BUILT_SLUGS.includes(page.slug) ? '/' + page.slug : '/404';
}

/** Slug-based route for a slug; falls back to /404 when the page is not built yet. */
export function routeForSlug(slug) {
  return BUILT_SLUGS.includes(slug) ? '/' + slug : '/404';
}
